import React, { Component } from 'react';
//import Header from './mainScreen/header';
//import Navbar from './mainScreen/navbar';
import SearchContextWrapper from '../../services/SearchContextWrapper';
import ContextWrapper from '../../services/ContextWrapper';
//import ZoomControl from './mainScreen/ZoomControl';

//import Modals from './modals.jsx';

class UserInterface extends Component {
  render() {
    return (
      <>
        {/*<Header />*/}
        {/*<Navbar />*/}
        <SearchContextWrapper />
        <ContextWrapper />
        {/*<ZoomControl />*/}
      </>
    );
  }
}

export default UserInterface;
